<template>
    <div>
       <BreadCrumb :data="breadCrumb" /> 
       <b-card class="Reports">
           <Form ref="ConstantsForm" :loading="loading" :data="constants" :forms="ConstantsForm" />
            
            <template v-slot:footer >
                <div style="display:flex; justify-content: flex-end; align-items: flex-end ">
                    <b-button variant="primary"  @click="saveData" >{{$t('general.save')}}</b-button>
                </div>

            </template>
        </b-card>
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Form from '@/components/Form'
    import Forms from './forms'
    import {prepareRequestData, setFormData} from '@/assets/js/custom.js'

    let breadCrumb = [
        { label: "Tanımlamalar", url: "/Definations" },
        { label: "Sabitler", url: "/Definations/Constants" },
    ]

    export default {
        name: 'ADManager',
        created: async function(){
            await this.$store.dispatch("constants_get")
        },
        computed: {
            loading(){
                return this.$store.getters.getLDAPLoading
            },
            constants(){
                return this.$store.getters.getConstants
            },
           
        },
        data:function(){
            return{
                breadCrumb,ConstantsForm: Forms.Constants
            }
        },
        components:{
            BreadCrumb, Form
        },
        methods:{
            saveData:  async function(){
                this.$refs.ConstantsForm.$refs.Form.validate().then( async success =>{
                    if(success){
                        let data = prepareRequestData(this.ConstantsForm, this.$refs.ConstantsForm.formData)
                        await this.$store.dispatch('constants_put', data)
                        if(this.$store.getters.getStatus.status == "Success"){
                            await this.$store.dispatch("constants_get")
                        }
                    }else{
                        return false
                    }
                })

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/General/Defination/Constants.vue